import React from 'react'
import tag from "../../../images/students/fishing.webp"

export default function FishingStory() {
    return (
        <div className='bg-[#FFFFFF] w-full md:w-11/12 mx-auto rounded-[14px] md:rounded-[44px] p-[25px] md:p-[50px] border border-[#007AFF26] mb-[50px] xl:mb-[70px] text-center' style={{ boxShadow: "0px 0px 25px -5px #00000033" }}>
            <div>
                <h4 className='text-[#101828] font-semibold text-[22px] md:text-[32px] lg:text-[44px] mt-[16px]'>SK’S FAMOUS FISHING STORY</h4>
                <p className='text-[#4A5565] font-normal text-[14px] md:text-[20px]'>Most systems try to give students fish — shortcuts, notes, placement promises.</p>
                <p className='text-[#101828] font-semibold text-[18px] md:text-[26px] mt-[12px] md:mt-[25px]'>But life doesn’t work that way.</p>
            </div>
            <img src={tag} alt='tag' loading='lazy' className='mx-auto size-[140px] md:size-[280px] mt-[20px] md:mt-[40px]' />
            <div className='mt-[20px] md:mt-[48px]'>
                <p className='text-[#101828] font-semibold text-[22px] md:text-[30px]'>But life doesn’t work that way.</p>
                <p className='text-[#4A5565] font-normal text-[18px] md:text-[28px] mt-[7px]'>Most systems try to give students fish — shortcuts, notes, placement promises.</p>
            </div>
            <div className='mt-[20px] md:mt-[48px] w-full mx-auto bg-[#EFF6FF] rounded-[10px] md:rounded-[20px] p-[12px] md:p-[24px] text-[#0057C6] font-medium text-[14px] md:text-[22px] lg:text-[25px]'>
                <p>A single hour of your journey can teach a student how to stand on their own feet.</p>
                <p className='mt-[5px] md:mt-[10px]'>— SK — </p>
            </div>
        </div>
    )
}
